/**
 * SignupBonusToast — passive confirmation that the one-time 30-credit signup
 * bonus was granted. Mounted globally (see layouts/Layout.tsx) since signup
 * can complete from any page (email confirm callback, OAuth redirect, magic
 * link). Pattern mirrors SaveNudge: pure toast, auto-dismisses, dismissible.
 */
import React, { useEffect } from 'react';
import { useSignupBonusToastStore } from '../../stores/signupBonusToastStore';
import './SignupBonusToast.css';

const AUTO_DISMISS_MS = 8000;

const SignupBonusToast: React.FC = () => {
  const message = useSignupBonusToastStore((s) => s.message);
  const hide = useSignupBonusToastStore((s) => s.hide);

  useEffect(() => {
    if (!message) return;
    const timer = window.setTimeout(hide, AUTO_DISMISS_MS);
    return () => window.clearTimeout(timer);
  }, [message, hide]);

  if (!message) return null;

  return (
    <div className="signup-bonus-toast" role="status">
      <span className="signup-bonus-toast__text">{message}</span>
      <button
        type="button"
        className="signup-bonus-toast__close"
        onClick={hide}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
};

export default SignupBonusToast;
